import { get, post, put, destroy } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "Timesheets";


export const findAll = async () => {
    return await get(baseRoute);
};

export const findById = async (id) => {
    return await get(baseRoute, "/" + id);
};

export const add = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "", data);
};

export const update = async (postData) => {
    var data = JSON.stringify(postData);
    return await put(baseRoute, "", data);
};

export const save = async (postData) => {
    if (postData.id !== undefined) {
        return await update(postData);
    } else {
        return await add(postData);
    }
};

export const remove = async (id) => {
    return await destroy(baseRoute, "", id);
};

export const search = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "search", data);
};

export const manage = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "manage", data);
};

export const getSchoolDays = async (classroomId, disciplineId, academicPeriodId) => {
    return await get(baseRoute, `/get_school_days/${classroomId}/${disciplineId}/${academicPeriodId}`);
};

const timesheetsService = {
    findAll,
    findById,
    add,
    update,
    save,
    remove,
    search,
    manage,
    getSchoolDays
}

export default timesheetsService;